module.exports = __webpack_public_path__ + "img/logo1.17732312.png";